import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import MobileStepper from '@material-ui/core/MobileStepper';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles } from '@material-ui/core/styles';
import UserProfileContext from 'on_web/context/userProfileContext';

import Box from '@material-ui/core/Box';

import DnaKitInstructionsStep0 from 'on_web/components/onboarding/dna/DnaKitInstructionsStep0';
import DnaKitInstructionsStep1 from 'on_web/components/onboarding/dna/DnaKitInstructionsStep1';
import DnaKitInstructionsStep2 from 'on_web/components/onboarding/dna/DnaKitInstructionsStep2';
import DnaKitInstructionsStep3 from 'on_web/components/onboarding/dna/DnaKitInstructionsStep3';
import DnaKitInstructionsStep4 from 'on_web/components/onboarding/dna/DnaKitInstructionsStep4';
import DnaKitInstructionsStep5 from 'on_web/components/onboarding/dna/DnaKitInstructionsStep5';
import DnaKitInstructionsStep6 from 'on_web/components/onboarding/dna/DnaKitInstructionsStep6';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';

function DnaKitInstructions(props) {
  const context = React.useContext(UserProfileContext);
  const [dnaKitInstructionsStep, setDnaKitInstructionsStep] = useState(
    context &&
      context.userData &&
      context.userData.user_metadata &&
      context.userData.user_metadata.dnaKitInstructionsStep
      ? context.userData.user_metadata.dnaKitInstructionsStep
      : 0
  );
  const [dnaKitCode, setDnaKitCode] = useState(
    context && context.genotype && context.genotype.source_details
      ? context.genotype.source_details.gxg_kit_number
      : undefined
  );

  const classes = makeStyles({
    root: {
      maxWidth: 400,
      flexGrow: 1,
    },
  });

  const saveCurrentStep = () => {
    const userMetadata = context ? context.userData.user_metadata : null;
    if (props.onNewStep && userMetadata) {
      userMetadata.dnaKitInstructionsStep = dnaKitInstructionsStep;
      props.onNewStep(userMetadata);
    }
  };

  const onClickNext = () => {
    if (dnaKitInstructionsStep === 0 && dnaKitCode) {
      // TODO: handle case when this is not a first DNA kit code submit (warn user?)
      if (props.onKitSubmit) {
        props.onKitSubmit(dnaKitCode);
      }
    }

    saveCurrentStep();

    if (dnaKitInstructionsStep < 6) {
      setDnaKitInstructionsStep(dnaKitInstructionsStep + 1);
    } else {
      if (props.onClickNext) {
        props.onClickNext();
      }
    }
  };

  const onClickBack = () => {
    saveCurrentStep();

    if (dnaKitInstructionsStep > 0) {
      setDnaKitInstructionsStep(dnaKitInstructionsStep - 1);
    } else {
      if (props.onClickBack) {
        props.onClickBack();
      }
    }
  };

  return (
    <div>
      <Header />
      {props.forPce === true && (
        <PceStepProgressIndicator selectedSlideIx={0} />
      )}

      <SwipeableViews index={dnaKitInstructionsStep}>
        <DnaKitInstructionsStep0
          onDnaKitCode={val => setDnaKitCode(val)}
          kitCode={dnaKitCode}
        />
        <DnaKitInstructionsStep1 />
        <DnaKitInstructionsStep2 />
        <DnaKitInstructionsStep3 />
        <DnaKitInstructionsStep4 />
        <DnaKitInstructionsStep5 />
        <DnaKitInstructionsStep6 />
      </SwipeableViews>
      <Box mr={{ xs: 2.5 }} justifyContent="center" display="flex">
        <MobileStepper
          variant="dots"
          steps={7}
          position="static"
          activeStep={dnaKitInstructionsStep}
          className={classes.root}
          onClick={ev => console.log(ev)}
        />
      </Box>

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={
          dnaKitInstructionsStep === 0 &&
          (dnaKitCode == null || dnaKitCode === '')
        }
      />
    </div>
  );
}

export default DnaKitInstructions;
